import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useFeatureFlag = (flagKey: string) => {
  const { data: flag, isLoading } = useQuery({
    queryKey: ['feature-flag', flagKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('is_enabled')
        .eq('flag_key', flagKey)
        .maybeSingle();

      // Uitgeschakelde flags zijn niet zichtbaar voor gewone gebruikers:
      // geen rij betekent simpelweg "uit", dat is geen fout.
      if (error) {
        return false;
      }

      return data?.is_enabled ?? false;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  return { isEnabled: flag ?? false, isLoading };
};
